module.exports = __webpack_public_path__ + "img/85ca9cccd4364fd8818956c22ec1169a.svg";